import { db } from '@/plugins/firebase';
import moment from 'moment';

export async function getDoronDoc(userId) {
  const doronDocQuerySnapShot = await db.collection('dorons').doc(userId).get();
  return doronDocQuerySnapShot.data();
}

export async function updateDoronDoc(userId, payload) {
  let success = true;
  payload['updatedAt'] = moment().toDate();

  const doronDocRef = await db.collection('dorons').doc(userId);
  await doronDocRef.set(payload, { merge: true }).catch(err => {
    console.error(err);
    success = false;
  });

  if (!success) return;

  const doronDocSnapShot = await doronDocRef.get();
  return doronDocSnapShot.data();
}
